import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { Article } from '@web/newsfeed/types/Article';
import { getArticlesQueryKey } from '@web/newsfeed/utils/getQueryKey';

export function useInitialArticles(pageId: ID, articles: Article[]) {
  const queryClient = useQueryClient();
  const queryKey = getArticlesQueryKey(pageId);

  return useMemo(() => {
    const initArticles = () => {
      const data = {
        pages: [articles],
        pageParams: [undefined],
      };
      queryClient.setQueryData(queryKey, data);
    };

    return {
      initArticles,
    };
  }, [articles, queryClient, queryKey]);
}
